import React from 'react';
import { Redirect } from 'react-router-dom';
import { isAuth0Enabled } from 'modules/auth/config/authConfig';

import Cookies from 'modules/_custom/pages/Axa/Cookies';

import CustomLogin from 'modules/auth/pages/CustomLogin';
import Legal from 'modules/_custom/pages/Axa/Legal';
import Login from 'modules/auth/pages/Login';
import LoginPLD from 'modules/auth/pages/LoginPLD';
import LoginPWC from 'modules/auth/pages/LoginPWC';
import Privacy from 'modules/_custom/pages/Axa/Privacy';
import TryDemo from 'modules/auth/pages/TryDemo';
import CognitoSamlCallback from 'modules/auth/pages/CognitoSamlCallback';

const DashboardRedirect = () => React.createElement(Redirect, { to: '/' });

export const unprotectedRoutes = [
  {
    id: 'demo',
    path: '/demo',
    component: TryDemo,
  },
  {
    id: 'login',
    path: '/login',
    component: isAuth0Enabled() ? Login : CustomLogin,
  },
  {
    id: 'pwc-login',
    path: '/pwc-login',
    component: LoginPWC,
  },
  {
    id: 'axa-privacy',
    path: '/:customPlatform/privacidad',
    component: Privacy,
    isNewUI: true,
  },
  {
    id: 'axa-cookies',
    path: '/:customPlatform/cookies',
    component: Cookies,
    isNewUI: true,
  },
  {
    id: 'axa-legal',
    path: '/:customPlatform/aviso-legal',
    component: Legal,
    isNewUI: true,
  },
  {
    id: 'pld-login',
    path: '/pld-login',
    component: LoginPLD,
  },
  {
    id: 'cognito-saml-callback',
    path: '/callback',
    component: CognitoSamlCallback,
  },
  // /dashboard is an alias for / (dashboard route); handles IdP redirects and bookmarks
  {
    id: 'dashboard-redirect',
    path: '/dashboard',
    component: DashboardRedirect,
  },
];
